import axiosInstance from "./AxiosInstance";
import {InterfaceReturn} from "../types/InterfaceReturn";
import {CommonReturn} from "../types/CommonReturn";
import {AxiosProgressEvent} from "axios";

export async function  procService<T>(method:string,serviceCode:string, requestParam:any):Promise<T>{
    return procRunService(method, `api/docuwiz/document/${serviceCode}`,serviceCode, requestParam, 'application/json', false);
};

export async function  procAdminService<T>(method:string,serviceCode:string, requestParam:any):Promise<T>{
    return procRunService(method, `api/admin/${serviceCode}`,serviceCode, requestParam, 'application/json', false);
};

export async function  procMultipartService<T>(method:string,serviceCode:string, requestParam:any):Promise<T>{
    const setMethod = method.toUpperCase();
    const response = await axiosInstance.request<InterfaceReturn<CommonReturn<T>>>(
        {
            method: setMethod,
            url: `api/docuwiz/document/multipart/${serviceCode}`,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress:function(data){
                console.log(data.loaded + "/" + data.total);
            },
            data:  requestParam,
        })

    return response.data.response.data;
};

export async function  procMultipartService2<T>(
            method:string
            , serviceCode:string
            , requestParam:any
            , runProgressFunc:(value:AxiosProgressEvent)=>void):Promise<T>
{
    const setMethod = method.toUpperCase();
    const response = await axiosInstance.request<InterfaceReturn<CommonReturn<T>>>(
        {
            method: setMethod,
            url: `api/docuwiz/document/multipart/${serviceCode}`,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress:runProgressFunc,
            data:  requestParam,
        })

    return response.data.response.data;
};

export async function  procFileDownLoad<T>(method:string,serviceCode:string, requestParam:any):Promise<T>{
    return procRunService(method,  `api/docuwiz/document/download/${serviceCode}`, serviceCode, requestParam, 'application/json', true);
};

export async function  procFileProcWithPercent<T>(method:string
                                                ,serviceCode:string
                                                , requestParam:any
                                                , runProgressFunc:(value:AxiosProgressEvent)=>void):Promise<T>{
        const setMethod = method.toUpperCase();
        return await axiosInstance.request(
                {
                    method: setMethod,
                    url: `api/docuwiz/document/download/${serviceCode}`,
                    headers: {
                    },
                    responseType : `blob`,
                    onDownloadProgress:runProgressFunc,
                    data:  setMethod !== "GET" ? requestParam : null,
                    params: setMethod === "GET" ? requestParam : null
                })
};

export async function  procRunService<T>(method:string,url:string, serviceCode:string, requestParam:any, contentType:string, isblob:boolean):Promise<T>{
    const setMethod = method.toUpperCase();
    const response = isblob ?
        await axiosInstance.request(
        {
            method: setMethod,
            url: url,
            headers: {
            },
            responseType : `blob`,
            data:  setMethod !== "GET" ? requestParam : null,
            params: setMethod === "GET" ? requestParam : null
        }) :
        await axiosInstance.request<InterfaceReturn<CommonReturn<T>>>(
            {
                method: setMethod,
                url: `api/docuwiz/document/${serviceCode}`,
                headers: {
                    'Content-Type': contentType,
                },
                data:  setMethod !== "GET" ? requestParam : null,
                params: setMethod === "GET" ? requestParam : null
            });

    return isblob ? response : response.data.response.data;
};


async function  procRunAdminService<T>(method:string,serviceCode:string, requestParam:any, contentType:string, isblob:boolean):Promise<T>{
    const setMethod = method.toUpperCase();
    const response = isblob ?
        await axiosInstance.request(
            {
                method: setMethod,
                url: `api/admin/${serviceCode}`,
                headers: {
                },
                responseType : `blob`,
                data:  setMethod !== "GET" ? requestParam : null,
                params: setMethod === "GET" ? requestParam : null
            }) :
        await axiosInstance.request<InterfaceReturn<CommonReturn<T>>>(
            {
                method: setMethod,
                url: `api/admin/${serviceCode}`,
                headers: {
                    'Content-Type': contentType,
                },
                data:  setMethod !== "GET" ? requestParam : null,
                params: setMethod === "GET" ? requestParam : null
            });

    return isblob ? response : response.data.response.data;
};